var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000151533382489603740040000017242568964838492572_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 816.4 264",
    style: {
      enableBackground: "new 0 0 816.4 264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#71A92C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.8,154.9V38.6h77v20.3h-52.4v27.7h47.3v20.3h-47.3v48.1H300.8L300.8,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.3,154.9V38.6h24.6v96.1h49.9v20.3H394.3L394.3,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M587.5,96.8c0,12.7-2.4,23.5-7.2,32.4s-11.3,15.7-19.5,20.4s-17.5,7-27.8,7s-19.6-2.4-27.8-7.1 s-14.7-11.5-19.5-20.4s-7.2-19.7-7.2-32.3s2.4-23.5,7.2-32.4c4.8-8.9,11.3-15.7,19.5-20.4s17.5-7,27.8-7s19.5,2.3,27.8,7 s14.8,11.5,19.5,20.4C585.1,73.3,587.5,84.1,587.5,96.8z M562.6,96.8c0-8.2-1.2-15.2-3.7-20.8c-2.4-5.6-5.9-9.9-10.3-12.8 s-9.6-4.4-15.6-4.4s-11.1,1.5-15.6,4.4s-7.9,7.2-10.3,12.8s-3.7,12.6-3.7,20.8s1.2,15.2,3.7,20.8c2.4,5.6,5.9,9.9,10.3,12.8 s9.6,4.4,15.6,4.4s11.1-1.5,15.6-4.4s7.9-7.2,10.3-12.8S562.6,105,562.6,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.3,154.9h27.2l-24.7-45.2c0.4-0.2,0.7-0.3,1.1-0.5c6.3-2.9,11.1-7.2,14.5-12.8s5-12.2,5-19.9 s-1.6-14.4-4.9-20.1c-3.3-5.7-8-10.1-14.3-13.2c-6.2-3.1-13.7-4.7-22.5-4.7h-45.9v116.4h24.6v-41.2h18L670.3,154.9L670.3,154.9z  M630.3,58.7h16.6c4.7,0,8.7,0.7,11.8,2.1s5.5,3.4,7,6c1.5,2.7,2.3,5.9,2.3,9.8s-0.8,7-2.3,9.6c-1.5,2.6-3.8,4.5-7,5.8 c-3.1,1.3-7,1.9-11.7,1.9h-16.7L630.3,58.7L630.3,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M790,154.9h26.4L776.3,38.6h-31.7l-40.2,116.4h26.4l8.6-26.5h42L790,154.9z M745.6,109.2l14.3-44h0.9 l14.3,44H745.6L745.6,109.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.8,189.1v36.4h-5.5v-36.4H495.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M544.6,189.1v36.4h-5l-18.5-26.7h-0.3v26.7h-5.5v-36.4h5.1l18.5,26.7h0.3v-26.7H544.6L544.6,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.1,225.4v-36.4h22.5v4.7h-17.1v11.1H585v4.7h-15.5v15.9L564.1,225.4L564.1,225.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636.5,207.2c0,3.9-0.7,7.2-2.1,10s-3.4,4.9-5.8,6.4c-2.5,1.5-5.3,2.2-8.4,2.2s-6-0.8-8.4-2.2 c-2.5-1.5-4.4-3.6-5.8-6.4c-1.4-2.8-2.1-6.1-2.1-10s0.7-7.2,2.1-10s3.4-4.9,5.8-6.4c2.5-1.5,5.3-2.2,8.4-2.2s5.9,0.8,8.4,2.2 s4.4,3.6,5.8,6.4S636.5,203.3,636.5,207.2L636.5,207.2z M631,207.2c0-3-0.5-5.4-1.4-7.5s-2.2-3.6-3.9-4.6 c-1.7-1.1-3.5-1.6-5.6-1.6s-4,0.5-5.6,1.6c-1.7,1.1-2.9,2.6-3.9,4.6c-1,2-1.4,4.5-1.4,7.5s0.5,5.4,1.4,7.5s2.2,3.6,3.9,4.6 c1.7,1.1,3.5,1.6,5.6,1.6s4-0.5,5.6-1.6c1.7-1.1,3-2.6,3.9-4.6C630.6,212.7,631,210.2,631,207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M651.5,193.8v-4.7h28.1v4.7h-11.3v31.6h-5.5v-31.6H651.5L651.5,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M697.3,225.4v-36.4h22.8v4.7h-17.3v11.1h16.1v4.7h-16.1v11.1h17.5v4.7L697.3,225.4L697.3,225.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M769.2,200.9h-5.5c-0.2-1.2-0.6-2.2-1.2-3.1c-0.6-0.9-1.3-1.7-2.1-2.3c-0.8-0.6-1.8-1.1-2.8-1.4 c-1-0.3-2.1-0.5-3.3-0.5c-2.1,0-4,0.5-5.6,1.6s-3,2.6-3.9,4.6c-1,2-1.4,4.5-1.4,7.5s0.5,5.5,1.4,7.5c1,2,2.3,3.6,3.9,4.6 s3.5,1.6,5.6,1.6c1.2,0,2.2-0.2,3.3-0.5c1-0.3,2-0.8,2.8-1.4c0.8-0.6,1.5-1.4,2.1-2.3s1-1.9,1.2-3.1l5.5,0 c-0.3,1.8-0.9,3.4-1.7,4.9c-0.8,1.5-1.9,2.8-3.2,3.9s-2.8,1.9-4.5,2.5s-3.5,0.9-5.5,0.9c-3.2,0-6-0.8-8.4-2.2 c-2.5-1.5-4.4-3.6-5.8-6.4c-1.4-2.8-2.1-6.1-2.1-10s0.7-7.2,2.1-10s3.4-4.9,5.8-6.4s5.3-2.2,8.4-2.2c1.9,0,3.7,0.3,5.4,0.8 s3.2,1.4,4.5,2.4c1.3,1.1,2.4,2.4,3.3,3.9S768.9,198.9,769.2,200.9L769.2,200.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M787.2,225.4v-36.4h5.5v15.8h18.1v-15.8h5.5v36.4h-5.5v-15.9h-18.1v15.9H787.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264,132c0,72.9-59.1,132-132,132c-2.5,0-5-0.1-7.5-0.2c-22.3-1.2-43.1-8-61.1-19C25.4,221.6,0,179.8,0,132 C0,59.1,59.1,0,132,0c45.2,0,85.1,22.7,108.9,57.4c7.9,11.5,14.1,24.4,18,38.2C262.2,107.1,264,119.4,264,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.4,101.7c0.4-1.6,1.4-3,2.7-4.2s2.9-1.9,4.8-1.9h96.1c-3.9-13.8-10.1-26.6-18-38.2L133,56.6 c-9.3,0-17.8,3.3-25.6,9.8S94.8,80.9,93,90.1L63.4,244.8c18,11,38.8,17.8,61.1,19l14.3-74.7h78.3l7.5-38.3h-78.3L155.4,101.7 L155.4,101.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 300.7,
    y: 205.6,
    className: "st0",
    width: 170,
    height: 3.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/Logo white.90a49fddd9ba89be6b8cd9bd1a99f223.svg";
export { ForwardRef as ReactComponent };